<template>
<v-container>
  <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>

  <v-row v-if="bPoint.mobile">
    <v-card-text>
      <v-expansion-panels flat accordion v-model="panel" tile>
        <v-expansion-panel>
          <v-expansion-panel-header class="clearExpansinHeaderPadding">{{ tf('Filters') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col class="clearColumnPadding my-2">
              <v-row class="justify-start">
                <v-col cols="11" class="form-builder-input ml-3 pl-1">
                  <VSelectAll
                    v-model="selectedVehicleGroups"
                    :items="select.vehicleGroups"
                    :label="tf('Vehicle groups')"
                  ></VSelectAll>
                </v-col>
                <v-col cols="11" class="form-builder-input ml-3 pl-1">
                  <VSelectAll
                    v-model="searchObject.vehicleIds"
                    :items="select.vehicles"
                    :label="tf('Vehicles')"
                  ></VSelectAll>
                </v-col>
                <v-col cols="11" class="form-builder-input ml-3 pl-1">
                  <VSelectAll
                    v-model="searchObject.incidentTypes"
                    :items="incidentTypeItems"
                    :label="tv('Incident types')"
                  ></VSelectAll>
                </v-col>
                <v-col cols="11" class="form-builder-input ml-3 pl-1">
                  <DateTimePickerFilter v-model="dateObj"></DateTimePickerFilter>
                </v-col>
                <v-col cols="12" class="form-builder-input pb-0">
                  <v-btn small color="primary" @click="search" class="mt-3 mr-3 white--text float-right">
                    {{ tf('search') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-row>

  <v-row>
    <v-col lg="9" xl="10">
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        :loading="loading"
        class="elevation-3"
        multi-sort
        id="genTable"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
      >
        <template v-slot:item.timestamp="{ item }">
          {{ formatTimestamp(item.timestamp) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon dense color="primary" @click="openPlayer(item)">mdi-play-circle</v-icon>
        </template>
      </v-data-table>
    </v-col>

    <v-col v-if="!bPoint.mobile" lg="3" xl="2" class="text-center" style="padding-bottom: 0px">
      <v-card>
        <v-card-title class="ml-2 pt-3 caption font-weight-bold">
          {{ tf('Filters') }}
        </v-card-title>
        <v-card-text class="pb-3">
          <v-row class="justify-start">
            <v-col cols="11" class="form-builder-input ml-3 pl-1">
              <VSelectAll
                v-model="selectedVehicleGroups"
                :items="select.vehicleGroups"
                :label="tf('Vehicle groups')"
              ></VSelectAll>
            </v-col>
            <v-col cols="11" class="form-builder-input ml-3 pl-1">
              <VSelectAll
                v-model="searchObject.vehicleIds"
                :items="select.vehicles"
                :label="tf('Vehicles')"
              ></VSelectAll>
            </v-col>
            <v-col cols="11" class="form-builder-input ml-3 pl-1">
              <VSelectAll
                v-model="searchObject.incidentTypes"
                :items="incidentTypeItems"
                :label="tv('Incident types')"
              ></VSelectAll>
            </v-col>
            <v-col cols="11" class="form-builder-input ml-3 pl-1">
              <DateTimePickerFilter v-model="dateObj"></DateTimePickerFilter>
            </v-col>
            <v-col cols="12" class="form-builder-input pb-0">
              <v-btn small color="primary" @click="search" class="mt-3 mr-3 white--text float-right">
                {{ tf('search') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <template>
      <v-dialog
        v-model="videoDialog"
        max-width="750px"
        :fullscreen="$vuetify.breakpoint.mobile"
        :retain-focus="false"
      >
        <StreamaxVideoPlayerDialog
          v-if="videoDialog"
          :incident="selectedIncident"
          @close="videoDialog = false"
        ></StreamaxVideoPlayerDialog>
      </v-dialog>
    </template>
  </v-row>
</v-container>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import httpClient from '@/api/httpClient'
import formatDate from '@/utils/formatDateHelper.js'
import VSelectAll from '@/components/custom/VSelectAll'
import DateTimePickerFilter from '@/components/v2/DateTimePickerFilter'
import StreamaxVideoPlayerDialog from '@/views/video/StreamaxVideoPlayerDialog'
import store from '@/store/store'

export default {
  name: 'StreamaxVideoPage',
  components: {
    VSelectAll,
    DateTimePickerFilter,
    StreamaxVideoPlayerDialog
  },
  data() {
    return {
      panel: 0,
      loading: false,
      selectedVehicleGroups: [],
      vehicles: [],
      select: {
        vehicleGroups: [],
        vehicles: []
      },
      searchObject: {
        vehicleIds: [],
        incidentTypes: []
      },
      dateObj: {},
      incidentTypeItems: [],
      items: [],
      selectedIncident: null,
      videoDialog: false,
      headers: [
        {
          text: translate('Incident Type', 'pages.video360'),
          value: 'alarmTypeLabel'
        },
        { text: translate('Vehicle', 'reportHeaders'), value: 'vehicleLabel' },
        { text: translate('Timestamp', 'reportHeaders'), value: 'timestamp' },
        {
          text: translate('Play', 'pages.video'),
          value: 'actions',
          sortable: false
        }
      ],
      itemsForNavigation: [
        {
          text: translate('360 View', 'navigation.video'),
          disabled: true
        }
      ]
    }
  },
  mounted() {
    httpClient.get('lookup/vehiclegroups').then(response => {
      for (let data of response.data) {
        this.select.vehicleGroups.push({ text: data.name, value: data.id })
      }
    })
    httpClient.get('vehicles?cameraType=1').then(response => {
      for (let data of response.data) {
        const obj = {
          text: data.name,
          value: data.id,
          vehicleGroupIds: data.vehicleGroupIds
        }
        this.vehicles.push(obj)
        this.select.vehicles.push(obj)
      }
    })
    httpClient.get('streamax/incident-types').then(response => {
      this.incidentTypeItems = response.data.map(t => ({
        text: t.name,
        value: t.id
      }))
    })
  },
  methods: {
    tf(key) {
      return translate(key, 'pages.serviceRealization')
    },
    tv(key) {
      return translate(key, 'pages.video')
    },
    formatTimestamp(ts) {
      if (!ts) return '-'
      return formatDate(ts, 'medium')
    },
    openPlayer(incident) {
      this.selectedIncident = incident
      this.videoDialog = true
    },
    search() {
      if (!this.searchObject.vehicleIds.length) return
      this.loading = true
      this.items = []
      httpClient
        .post('streamax/incidents', {
          vehicleIds: this.searchObject.vehicleIds,
          startDate: this.dateObj.startDate,
          endDate: this.dateObj.endDate,
          incidentTypes: this.searchObject.incidentTypes
        })
        .then(response => {
          this.items = response.data
        })
        .catch(err => {
          store.dispatch('notification/add', { type: 'error', message: err.response.data.Message }, { root: true })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    }
  },
  watch: {
    selectedVehicleGroups: {
      handler() {
        if (this.selectedVehicleGroups.length === 0) {
          this.select.vehicles = this.vehicles
        } else {
          this.select.vehicles = this.vehicles.filter(
            v =>
              v.vehicleGroupIds &&
              v.vehicleGroupIds.some(gId =>
                this.selectedVehicleGroups.includes(gId)
              )
          )
        }
      }
    }
  }
}
</script>

<style scoped>
#genTable >>> thead > tr > th {
  background-color: var(--primary-color);
  color: white;
}
</style>
